import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = "http://localhost:8000/api/categories";

export const fetchCategoriesByType = createAsyncThunk(
  "categories/fetchByType",
  async (type, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/${type}/all`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur lors de la récupération des catégories");
    }
  }
);

const categorySlice = createSlice({
  name: "categories",
  initialState: {
    items: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoriesByType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCategoriesByType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchCategoriesByType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default categorySlice.reducer;
